import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';

import { DatePipe } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  MAT_DATE_LOCALE,
  provideNativeDateAdapter,
} from '@angular/material/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { API_CONFIG, TENANT_BRANDING } from '@contracts';
import { AuthBearerInterceptor, I18nService } from '@core';
import { provideTranslateService } from '@ngx-translate/core';
import { provideEcharts } from 'ngx-echarts';
import { moduleInitializer } from 'projects/lib/core/src/lib/service/modules/module-initial';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { apiEndpointsProvider } from './core/config/api-endpoints.provider';
import { APP_ROUTE_CONFIG_PROVIDER } from './core/config/app.config';
import { APP_METER_PROVIDER_BILLENIUM } from './core/config/meter-column.provider';

export const appConfig: ApplicationConfig = {
  providers: [
    DatePipe,
    { provide: MAT_DATE_LOCALE, useValue: 'th-TH' },
    provideRouter(
      routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),
    ),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    provideNativeDateAdapter(),
    provideTranslateService({
      lang: 'th',
      fallbackLang: 'en',
    }),
    {
      provide: API_CONFIG,
      useValue: {
        apiUrl: environment.api_url,
        apiVersion: environment.api_version,
      },
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (i18n: I18nService) => () => i18n.init(),
      deps: [I18nService],
      multi: true,
    },
    {
      provide: TENANT_BRANDING,
      useValue: {
        siteName: '',
        logoMain: 'assets/shared/images/branding/logo-main.png',
        logoFooter: 'assets/shared/images/branding/logo-footer.png',
        loginVisual: 'assets/shared/images/branding/login-visual.png',
      },
    },
    apiEndpointsProvider,
    APP_ROUTE_CONFIG_PROVIDER,
    moduleInitializer,
    provideEcharts(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthBearerInterceptor,
      multi: true,
    },
    APP_METER_PROVIDER_BILLENIUM
  ],
};
